/** @format */

import React from 'react';
import update from 'immutability-helper';
import SuperAgent from 'superagent';
import Moment from 'moment';
import {getFilestackPolicy, getFilestackSignature} from 'frontier-utilities';
import {
    DESIGN_UPLOAD_MIMETYPES,
    FILESTACK_SERVICES,
    REGEX_DESIGN_FILENAME
} from 'frontier-constants';
import * as Filestack from 'filestack-js';

const artworkThumbPathStore = fileKey => {
    return process.env.FILESTACK_ARTWORK_THUMB_STORE_PATH.replace(
        '{{filename}}',
        fileKey.replace(/[^0-9a-z]/gi, '-') + '.png'
    );
};

const fileStackClient = permissions => {
    const expires = Moment().unix() + 300;
    const policy = getFilestackPolicy(expires, permissions);
    const signature = getFilestackSignature(policy);

    return Filestack.init(process.env.FILESTACK_KEY, {
        policy: policy,
        signature: signature
    });
};

const handlePickAutoUpload = async (customPickOptions, file) => {
    const client = fileStackClient(['store', 'convert', 'read']);

    // checking options for "client.upload" method. Notice it's different than "client.picker(opts).open()
    const defaultPickOptions = {
        accept: DESIGN_UPLOAD_MIMETYPES,
        maxFiles: 200,
        fromSources: FILESTACK_SERVICES,
        onOpen: () => {},
        onUploadDone: res => {
            console.log('upload not handled');
        }
    };

    const pickOptions = update(defaultPickOptions, customPickOptions);
    return await client.upload(file);
};

const handlePick = async customPickOptions => {
    const client = fileStackClient(['pick']);

    const defaultPickOptions = {
        accept: DESIGN_UPLOAD_MIMETYPES,
        maxFiles: 200,
        fromSources: FILESTACK_SERVICES,
        onOpen: () => {},
        onUploadDone: res => {
            console.log('upload not handled');
        }
    };

    const pickOptions = update(defaultPickOptions, customPickOptions);

    return client.picker(pickOptions).open();
};
const isValidMimetype = (mimetype, acceptedTypes) => {
    return acceptedTypes.indexOf(mimetype) > -1;
};

const handleUpload = async (file, configOptions, acceptedTypes, storeUploadOptions = {}) => {
    const types = typeof acceptedTypes === 'undefined' ? DESIGN_UPLOAD_MIMETYPES : acceptedTypes;
    if (acceptedTypes !== '*' && !isValidMimetype(file.type, types)) {
        throw new Error('I cannot accept [' + file.type + '] file type.');
    }
    const client = fileStackClient(['store', 'convert', 'read']);
    const defaultConfig = {};
    // Make sure the uploaded file key/filename has no special characters
    const defaultStoreUploadOptions = {filename: file.name.replace(REGEX_DESIGN_FILENAME, '')};
    const config = update(defaultConfig, configOptions);
    const storeUploadConfig = update(defaultStoreUploadOptions, storeUploadOptions);
    return client.upload(file, config, storeUploadConfig);
};

const handleConvert = async (fileUrl, configUpdate) => {
    const defaultConfig = {
        format: 'png',
        storePath: '',
        storeContainer: process.env.FILESTACK_ARTWORK_THUMB_CONTAINER,
        key: process.env.FILESTACK_KEY
    };
    const convertConfig = update(defaultConfig, configUpdate);

    return SuperAgent.get(fileUrl + '/convert').query(convertConfig);
};

const handleImageSize = async fileHandle => {
    const defaultConfig = {
        key: process.env.FILESTACK_KEY
    };

    return SuperAgent.get(process.env.FILESTACK_PROCESS_URL + '/imagesize/' + fileHandle).query(
        defaultConfig
    );
};

const rmExt = filename => {
    return filename.replace(/\..+$/, '');
};

const replaceExt = (filename, ext) => {
    return filename.replace(/\..+$/, '.' + ext);
};

const handleSaveUpload = async (endpoint, fileData) => {
    return await SuperAgent.post(endpoint).set('Accept', 'application/json').send(fileData);
};

export {
    artworkThumbPathStore, // custom path store
    handlePick, // Generate a picker box popup
    handleConvert, // Convert a file
    handleUpload,
    rmExt, // remove a file extension
    replaceExt, // Replace the file extention
    handleSaveUpload, // Persist to an endpoint
    fileStackClient,
    handlePickAutoUpload // custom upload without picker modal
};
